import { useCallback, useMemo } from 'react';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Spacer } from 'foundations-components/components/Spacer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DeleteMetricButton from './DeleteMetricButton';
import { SUM } from 'reporting-data/constants/metricTypes';
import BaseSelectComponent from '../../shared-components/BaseSelectComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MetricsEditorInputGroup = ({
  'data-test-id': dataTestId = 'metrics-editor',
  buttonUse,
  deleteDisabled = false,
  dropdownFooter,
  aggregationOptions,
  metricIndex,
  onChange,
  onDelete,
  propertyOptions,
  reportMetric,
  aggregationDisabled = false,
  aggregationDisabledReason
}) => {
  const handlePropertyChange = useCallback(event => {
    onChange(Object.assign({}, reportMetric, {
      property: event.target.value
    }));
  }, [onChange, reportMetric]);
  const handleAggregationChange = useCallback(({
    target: {
      value
    }
  }) => {
    onChange(Object.assign({}, reportMetric, {
      aggregation: value
    }));
  }, [onChange, reportMetric]);
  const aggregationValue = useMemo(() => {
    var _aggregationOptions$;
    const value = reportMetric.aggregation || SUM;

    // In some cases, user can change property and aggregation at the same time.
    if (aggregationOptions.some(option => option.value === value)) {
      return value;
    }
    const updatedValue = (_aggregationOptions$ = aggregationOptions[0]) === null || _aggregationOptions$ === void 0 ? void 0 : _aggregationOptions$.value;
    if (updatedValue) {
      onChange(Object.assign({}, reportMetric, {
        aggregation: updatedValue
      }));
    }
    return updatedValue;
  }, [reportMetric, aggregationOptions, onChange]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(InputGroup, {
      "data-test-id": dataTestId,
      label: /*#__PURE__*/_jsxs(TFlex, {
        direction: "row",
        align: "center",
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.metrics-editor-dropdown.config.properties.tooltip"
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.metrics-editor-dropdown.config.properties.label"
          })
        }), /*#__PURE__*/_jsx(DeleteMetricButton, {
          onClick: onDelete,
          disabled: deleteDisabled
        })]
      }),
      children: /*#__PURE__*/_jsx(BaseSelectComponent, {
        value: reportMetric.property,
        options: propertyOptions,
        onChange: handlePropertyChange,
        dropdownFooter: dropdownFooter,
        buttonUse: buttonUse,
        "data-test-id": `${dataTestId}-property-${metricIndex}`
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "200"
    }), /*#__PURE__*/_jsx(InputGroup, {
      children: /*#__PURE__*/_jsx(BaseSelectComponent, {
        disabled: aggregationDisabled,
        value: aggregationValue,
        options: aggregationOptions,
        onChange: handleAggregationChange,
        buttonUse: buttonUse,
        tooltipText: aggregationDisabled ? aggregationDisabledReason : undefined,
        useDefaultValueComponent: !aggregationDisabled || !aggregationDisabledReason,
        "data-test-id": `${dataTestId}-aggregation-${metricIndex}`
      })
    })]
  });
};
export default MetricsEditorInputGroup;